import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import * as configuration from './configuration/configuration';
import AppContainer from './containers/app-container/AppContainer';
import { ToastContainer } from 'react-toastify';
import { createPluginStore, PluginProvider, RendererPlugin } from 'react-pluggable';
import { Provider } from 'react-redux';
import store from './store/store';
import OrderEmailConfirmation from './components/order-email-confirmation/OrderEmailConfirmation';
import SetFixcenterFooterPlugin from './plugins/SetFixcenterFooterPlugin';
import RegisterCompanyPlugin from './plugins/RegisterCompanyPlugin';
import CreateNewAccountHeaderPlugin from './plugins/CreateNewAccountHeaderPlugin';
import ResetPasswordPlugin from './plugins/ResetPasswordPlugin';
import RegisterNowPlugin from './plugins/RegisterNowPlugin';
import LoginFormPlugin from './plugins/LoginFormPlugin';
import FixcenterProductsPagePlugin from './plugins/FixcenterProductsPagePlugin';
import { getLanguageCode, LANGUAGE_CODES } from './shared/services/language.service';
import CompanySettingsInitialize from './shared/initialize/company-settings-initialize';

const pluginStore = createPluginStore();

pluginStore.install(new RendererPlugin());
pluginStore.install(new SetFixcenterFooterPlugin());
pluginStore.install(new LoginFormPlugin());
pluginStore.install(new RegisterNowPlugin());
pluginStore.install(new ResetPasswordPlugin());
pluginStore.install(new RegisterCompanyPlugin());
pluginStore.install(new CreateNewAccountHeaderPlugin());
pluginStore.install(new FixcenterProductsPagePlugin());

function App() {
    const location = useLocation();
    useEffect(() => {
        const languageCode = getLanguageCode();

        localStorage.setItem('lang', languageCode);

        const currentPath = location.pathname;
        const currentLanguage = currentPath.split('/')[1];

        if (currentLanguage !== languageCode && LANGUAGE_CODES.includes(currentLanguage)) {
            const newPath = currentPath.replace(`/${currentLanguage}`, `/${languageCode}`);

            return window.history.replaceState(null, '', newPath);
        }

        if (!currentPath.startsWith(`/${languageCode}`) && !LANGUAGE_CODES.includes(currentLanguage)) {
            const newPath = `/${languageCode}${currentPath}`;

            return window.history.replaceState(null, '', newPath);
        }
    }, [location]);

    configuration.configure();
    return (
        <PluginProvider pluginStore={pluginStore}>
            <Provider store={store}>
                <ToastContainer />
                <CompanySettingsInitialize />
                <Routes>
                    <Route path="/*" Component={AppContainer}></Route>
                    <Route path="/order-email-confirmation/*" Component={OrderEmailConfirmation}></Route>
                </Routes>
            </Provider>
        </PluginProvider>
    );
}

export default App;
